export default {
  title: 'Exchange Record',
  giftInfo: 'Gift Info',
  giftInfoPlaceholder: 'Please enter keyword',
  memberInfo: 'Member Info',
  memberInfoPlaceholder: 'Please enter keyword',
  shipStatus: 'Shipping Status',
  exchangeTime: 'Exchange Time',
  startDate: 'Start Date',
  endDate: 'End Date',
  country: 'Country',
  exchangePrice: 'Exchange Price',
  exchangeQty: 'Quantity',
  contactPhone: 'Contact Phone',
  shippingAddress: 'Shipping Address',
  spec: 'Spec',
  specName: 'Spec',
  singleSpec: 'Single Spec',
  statusPending: 'Pending',
  statusShipped: 'Shipped',
  statusAll: 'All',
  statusRedeemed: 'Redeemed',
  statusCompleted: 'Completed',
  statusCancelled: 'Cancelled',
  statusFailed: 'Failed',
  ship: 'Ship',
  detail: 'Detail',
  shipModalTitle: 'Ship',
  shipDetailTitle: 'Shipping Info',
  expressCompany: 'Carrier',
  expressCompanyPlaceholder: 'Please enter carrier name',
  trackingNo: 'Tracking No.',
  trackingNoPlaceholder: 'Please enter tracking number',
  remark: 'Remark',
  remarkPlaceholder: 'Please enter remark',
  expressCompanyRequired: 'Please enter carrier',
  trackingNoRequired: 'Please enter tracking number',
  timeRequired: 'Please select exchange time',
};
